
<div class="card card-login">
  <div class="card-content">
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center">
          <img [src]="this.logoPath" [ngClass]="this.ulsterOrganisationId ? 'logoUlster' : 'logo'" alt="able+" title="able+" />
        </div>
      </div>
      <p style="margin-left: 43px">{{ responseMessage }}</p>
    </div>
    <div>
      <ng-container *ngIf="responseOptionType && responseOptionType == '2'">
        <div *ngFor="let option of optionsList">
          <div class="radio radio-inline">
            <label style="color: #000000;">
              <input
                type="radio"
                [(ngModel)]="userPromptAnswerToSend"
                name="response"
                [value]="option"
              />{{ option }}
            </label>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="responseOptionType && responseOptionType == '1'">
        <textarea
          rows="5"
          [(ngModel)]="userPromptAnswerToSend"
          cols="42"
          [maxLength]="characterLimit"
        ></textarea
        ><br />
        <br />
      </ng-container>
      <br />
      <button
        class="btn btn-block btn-primary"
        type="submit"
        #button
        (click)="submitResponse()"
        [disabled]="responseSubmitted"
        [ngStyle]="this.ulsterOrganisationId ? {'background-color': '#061E42', color: this.sharedService.TextButtonColor.value, 'font-weight': 'bold',  'width': '97px', 'margin-left': '178px'} : {'background-color': this.sharedService.ButtonColor.value, color: this.sharedService.TextButtonColor.value}"
      >
        Submit
      </button>
    </div>
  </div>
</div>
